// extracted by mini-css-extract-plugin
export var avatarContainer = "_at-0";
export var avatarTypingWave = "_at-i";
export var gray = "_at-f";
export var green = "_at-c";
export var icon = "_at-9";
export var image = "_at-1";
export var lg = "_at-6";
export var md = "_at-5";
export var presenceDot = "_at-b";
export var red = "_at-d";
export var sm = "_at-4";
export var status = "_at-a";
export var typingDot = "_at-h";
export var typingPill = "_at-g";
export var xl = "_at-7";
export var xs = "_at-3";
export var xxl = "_at-8";
export var xxs = "_at-2";
export var yellow = "_at-e";